////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router'
import styled from 'styled-components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import { articleLifeManagerActionCreators } from '../../../../../store/actions'
import ArticleDatePicker from '../ArticleDatePicker'

/////////STYLED/////////
const ModifyStopDepositWrapper = styled.div``
/////////STYLED/////////
// [63]_d): MODIFY STOP DEPOSIT

const ModifyStopDeposit = (props) => {
	const match = useRouteMatch()

	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	const [dateToModify, setDateToModify] = useState(new Date())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleChangeDate = (date) => {
		setDateToModify(date)
	}

	const handleValidate = () => {
		actionsArticleLifeManager.updateStopDepositAction(match.params.id, dateToModify)
		handleCloseDatePicker()
	}

	const handleCloseDatePicker = () => {
		props.modifyStopDeposit.close()
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (props.modifyStopDeposit?.item?.dateToModify)
			if (props.modifyStopDeposit.show) handleChangeDate(new Date(props.modifyStopDeposit.item.dateToModify))
	}, [props.modifyStopDeposit.show])

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.modifyStopDeposit.close()
	}, [articleLifeManager?.isUpdate])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModifyStopDepositWrapper>
			<ArticleDatePicker
				showModal={props.modifyStopDeposit.show}
				date={dateToModify}
				handleValidate={handleValidate}
				handleClose={handleCloseDatePicker}
				handleChangeDate={handleChangeDate}
				title={translations['modal__itemRef__timeline_action_consignment_endDate_edit_title']}
				postLimit={props.modifyStopDeposit?.item?.dateLimit}
			/>
		</ModifyStopDepositWrapper>
	)
}

ModifyStopDeposit.propTypes = {}

ModifyStopDeposit.defaultPropTypes = {}

export default ModifyStopDeposit
